import { render, staticRenderFns } from "./SubmitFly.vue?vue&type=template&id=2cc5938e"
import script from "./SubmitFly.vue?vue&type=script&lang=js"
export * from "./SubmitFly.vue?vue&type=script&lang=js"
import style0 from "./SubmitFly.vue?vue&type=style&index=0&id=2cc5938e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports